import { render } from "./PlatformNavbar.vue?vue&type=template&id=497555c5&scoped=true"
import script from "./PlatformNavbar.vue?vue&type=script&lang=js"
export * from "./PlatformNavbar.vue?vue&type=script&lang=js"

import "./PlatformNavbar.vue?vue&type=style&index=0&id=497555c5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497555c5"]])

export default __exports__